import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';

const SURVEY_ILLUSTRATION_MAP: Record<string, IllustrationKeyType> = {
  DIRECT_DEPOSIT: 'PAYCHECK_A',
  PAYMENT_APP: 'CASHAPP_A',
  CASH: 'CASH_C',
  CHECK: 'SIGN_A',
  ANOTHER_WAY: 'COINS_B',
} as const;

export const getSurveyIllustration = (
  optionType: string | undefined,
): IllustrationKeyType => {
  return optionType ? SURVEY_ILLUSTRATION_MAP[optionType] : 'CASH_A';
};
